<template>
  <div style="width: 100%;">
    <div v-if="messages && messages.length > 0">
      <draggable v-model="messages" v-bind="dragOptions" @end="onDragEnd">
        <transition-group type="transition" name="flip-list">
           <!-- class="draggable-item" -->
            <v-row
              v-for="(message, idx) in messages"
              :key="message.uuid"
            >
              <!-- style="display: inline-block; width: 10%;" -->
              <v-col v-if="editionMode" class="draggable-item" md="1">
                <v-icon :class="editionMode ? 'draggable' : ''">{{ editionMode ? 'mdi-drag' : 'mdi-blank' }}</v-icon>
              </v-col>
              <!-- style="display: inline-block; width: 90%;" -->
              <v-col class="mx-2">
                 <BackendMessage 
                  :editionMode="editionMode"
                  :message="message" 
                  :messageIdx="idx"
                  :availableLanguages="availableLanguages"
                  :jsonpath="`${jsonpath}[${idx}]`"
                  @change="messageChanged"
                  @delete="messageDeleted"
                ></BackendMessage>
              </v-col>
            </v-row>
        </transition-group>
      </draggable>
    </div>
    <div v-if="editionMode && (!maxMessages || messages.length < maxMessages)" >
      <a @click="createMessage">{{ $t('messages.label.createMessage') }}</a>
    </div>
  </div>  
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import BackendMessage from "./BackendMessage"
import draggable from "vuedraggable";
import { mapState } from "vuex"

export default {
  props: ["editionMode", "maxMessages", "messages", "jsonpath"],
  components: {
    BackendMessage,
    draggable,
  },
  data() {
    return {
      availableLanguages: ["en", "fr"],
    }
  },
  computed: {
    ...mapState("project", ["language"]),
    dragOptions() {
      return {
        animation: 0,
        disabled: !this.editionMode,
        ghostClass: "ghost"
      };
    },
  },
  methods: {
    onDragEnd(evt) {
      this.$emit("change", { jsonpath: this.jsonpath, op: { name: "move", value: {
        oldIndex: evt.oldIndex,
        newIndex: evt.newIndex,
      }}})
    },
    messageChanged(event) {
      this.$emit("change", event)
    },
    messageDeleted(event) {
      this.$emit("change", { jsonpath: this.jsonpath, op: { name: "remove", value : event }})
    },
    createMessage() {
      this.$emit("change", { jsonpath: this.jsonpath, op: { name: "add", value: {
        uuid: uuidv4(),
        localized: [ { 
          uuid: uuidv4(), 
          language: this.availableLanguages.indexOf(this.language) != -1 ? this.language : this.$i18n.locale, 
          title: "", 
          body: "" 
        } ]
      }}})
    },
  }
}
</script>
